(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mode = this.dataset.mode;
      this.handleQueryChange = () => this.setupItems();
      this.mobileQuery.addEventListener('change', this.handleQueryChange);
      this.setupItems();
    }

    disconnectedCallback() {
      this.teardown();
      if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.handleQueryChange);
    }

    setupItems() {
      this.teardown();

      this.useColumnsAsSlides = this.mode === 'columns' && this.mobileQuery.matches;
      this.useSlider = this.mode === 'slider';

      if (!this.useColumnsAsSlides && !this.useSlider) return;

      const selector = this.useColumnsAsSlides ? '.announcement-bar__column' : '.announcement-bar__slide';
      this.slides = Array.from(this.querySelectorAll(selector));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) {
        this.currentIndex = 0;
        this.slides[0].classList.add('is-active');
      }
      this.isAnimating = false;
      this.animationDuration = 450;

      if (this.useSlider) {
        this.prevButton = this.querySelector('.announcement-bar__button--prev');
        this.nextButton = this.querySelector('.announcement-bar__button--next');
        this.handlePrev = () => this.showSlide(this.currentIndex - 1);
        this.handleNext = () => this.showSlide(this.currentIndex + 1);
        if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
        if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);
      }

      const autoplayEnabled = this.useColumnsAsSlides || this.dataset.autoplay === 'true';
      if (autoplayEnabled && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    teardown() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
      this.slides = [];
      this.prevButton = null;
      this.nextButton = null;
    }

    showSlide(index) {
      if (this.isAnimating || !this.slides || !this.slides.length) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = this.useColumnsAsSlides ? 3000 : (Number(this.dataset.interval) || 4000);
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jack-emma-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  class JackEmmaPhotoReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-jepr-track]');
      if (!this.track) return;

      this.prevBtn = this.querySelector('[data-jepr-prev]');
      this.nextBtn = this.querySelector('[data-jepr-next]');
      this.dotsWrap = this.querySelector('[data-jepr-dots]');
      this._pages = 1;
      this._perViewCache = this._perView();
      this._resizeTimer = null;

      this._autoplayTimer = null;
      this._autoplayDesktop = this.dataset.autoplayDesktop === 'true';
      this._autoplayDesktopInterval = (parseFloat(this.dataset.autoplayDesktopInterval) || 10) * 1000;

      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
      this._onVisibilityChange = this._onVisibilityChange.bind(this);
      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onMouseLeave = this._onMouseLeave.bind(this);

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this._step(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this._step(1));
      }

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this.track.addEventListener('keydown', this._onKeydown);
      this.track.addEventListener('touchstart', this._onTouchStart, { passive: true });
      this.track.addEventListener('touchend', this._onTouchEnd, { passive: true });
      this.addEventListener('mouseenter', this._onMouseEnter);
      this.addEventListener('mouseleave', this._onMouseLeave);
      window.addEventListener('resize', this._onResize);
      document.addEventListener('visibilitychange', this._onVisibilityChange);

      this._buildDots();
      this._update();
      this._startAutoplay();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
      this.removeEventListener('mouseenter', this._onMouseEnter);
      this.removeEventListener('mouseleave', this._onMouseLeave);
      if (this.track) {
        this.track.removeEventListener('scroll', this._onScroll);
        this.track.removeEventListener('keydown', this._onKeydown);
        this.track.removeEventListener('touchstart', this._onTouchStart);
        this.track.removeEventListener('touchend', this._onTouchEnd);
      }
      if (this._resizeTimer) clearTimeout(this._resizeTimer);
      this._stopAutoplay();
    }

    _reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    _perView() {
      var w = window.innerWidth;
      if (w >= 990) return 3;
      if (w >= 750) return 2;
      return 1;
    }

    _cardStep() {
      var card = this.track.querySelector('[data-jepr-card]');
      if (!card) return 0;
      var style = window.getComputedStyle(this.track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    _step(direction) {
      var step = this._cardStep();
      if (!step) return;
      this.track.scrollBy({ left: direction * step, behavior: this._reducedMotion() ? 'auto' : 'smooth' });
    }

    _startAutoplay() {
      this._stopAutoplay();
      if (this._reducedMotion()) return;
      if (document.hidden) return;

      var perView = this._perView();
      var interval;
      if (perView === 1) {
        interval = 3000;
      } else {
        if (!this._autoplayDesktop) return;
        interval = this._autoplayDesktopInterval;
      }

      var track = this.track;
      if (track.scrollWidth - track.clientWidth <= 2) return;
      var self = this;
      this._autoplayTimer = setInterval(function () {
        self._autoplayAdvance();
      }, interval);
    }

    _stopAutoplay() {
      if (this._autoplayTimer) {
        clearInterval(this._autoplayTimer);
        this._autoplayTimer = null;
      }
    }

    _autoplayAdvance() {
      var track = this.track;
      var perView = this._perView();
      var step = this._cardStep();
      if (!step) return;
      var pageWidth = step * perView;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atEnd = track.scrollLeft >= maxScroll - 2;
      if (atEnd) {
        track.scrollTo({ left: 0, behavior: this._reducedMotion() ? 'auto' : 'smooth' });
      } else {
        track.scrollBy({ left: pageWidth, behavior: this._reducedMotion() ? 'auto' : 'smooth' });
      }
    }

    _onTouchStart() {
      this._stopAutoplay();
    }

    _onTouchEnd() {
      this._startAutoplay();
    }

    _onMouseEnter() {
      this._stopAutoplay();
    }

    _onMouseLeave() {
      this._startAutoplay();
    }

    _onVisibilityChange() {
      if (document.hidden) {
        this._stopAutoplay();
      } else {
        this._startAutoplay();
      }
    }

    _buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';

      var cards = this.track.querySelectorAll('[data-jepr-card]').length;
      var perView = this._perView();
      var pages = Math.max(1, Math.ceil(cards / perView));

      this._pages = pages;
      this._perViewCache = perView;

      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'jack-emma-photo-reviews__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to review page ' + (i + 1));
        dot.addEventListener('click', this._goToPage.bind(this, i));
        this.dotsWrap.appendChild(dot);
      }
    }

    _goToPage(index) {
      var step = this._cardStep();
      var left = index * this._perViewCache * step;
      this.track.scrollTo({ left: left, behavior: this._reducedMotion() ? 'auto' : 'smooth' });
    }

    _onResize() {
      var self = this;
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(function () {
        var newPerView = self._perView();
        if (newPerView !== self._perViewCache) {
          self._buildDots();
        }
        self._update();
        self._startAutoplay();
      }, 150);
    }

    _onScroll() {
      var self = this;
      window.requestAnimationFrame(function () {
        self._update();
      });
    }

    _onKeydown(event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this._step(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this._step(-1);
      }
    }

    _update() {
      var track = this.track;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;
      var noScroll = maxScroll <= 2;

      if (this.prevBtn) {
        this.prevBtn.disabled = atStart;
        this.prevBtn.style.display = noScroll ? 'none' : '';
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = noScroll ? true : atEnd;
        this.nextBtn.style.display = noScroll ? 'none' : '';
      }

      if (this.dotsWrap) {
        this.dotsWrap.style.display = this._pages <= 1 ? 'none' : '';

        if (this._pages > 1) {
          var step = this._cardStep();
          var pageWidth = step * this._perViewCache;
          var current = pageWidth > 0 ? Math.round(track.scrollLeft / pageWidth) : 0;
          current = Math.max(0, Math.min(current, this._pages - 1));

          var dots = this.dotsWrap.querySelectorAll('.jack-emma-photo-reviews__dot');
          for (var i = 0; i < dots.length; i++) {
            var isActive = i === current;
            dots[i].classList.toggle('is-active', isActive);
            dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
          }
        }
      }
    }
  }

  if (!customElements.get('jack-emma-photo-reviews')) {
    customElements.define('jack-emma-photo-reviews', JackEmmaPhotoReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
